import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

type TaskType = 'project' | 'task'

export type GetPortfolioGanttResponse = {
  start: string
  end: string
  name: string
  id: string
  type: TaskType
  hideChildren: boolean
  displayOrder: number
  progress: number
}

type PortfolioGanttProps = {
  portfolioId: string
  query: QueryParams
}

export const getPortfolioGantt = async ({
  portfolioId,
  query,
}: PortfolioGanttProps) => {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<GetPortfolioGanttResponse[]>(
    `/projects/portfolios/${portfolioId}/gantt?${queryParams}`,
  )

  return data
}
